
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./global-payments.cjs.production.min.js')
} else {
  module.exports = require('./global-payments.cjs.development.js')
}
